import type { SurveillancePolicy } from "@whatslly/types/surveillance/SurveillancePolicy";
import type { IPolicyStore } from "../shared/stores/IPolicyStore";
export interface ISurveillanceStore extends IPolicyStore<SurveillancePolicy> {
  getPolicyById(policyId: string): Promise<SurveillancePolicy | undefined>;
  savePolicy(policy: SurveillancePolicy, isEditMode?: boolean): Promise<void>;
}

export const InjectSurveillanceStore = Symbol.for("SurveillanceStore");
